import { Injectable } from '@angular/core';
import { DocumentoAllegato } from '../documento-allegato';
import { LegaleIncaricato } from '../legale-incaricato';

@Injectable()
export class LegaleIncaricatoAdapter {

  legaleIncaricato: LegaleIncaricato = new LegaleIncaricato();

  constructor(legaleIncaricato: LegaleIncaricato) {
    this.legaleIncaricato.id = legaleIncaricato.id;
    this.legaleIncaricato.categoriaLegaleIncaricato =
      legaleIncaricato.categoriaLegaleIncaricato ? JSON.parse(JSON.stringify(legaleIncaricato.categoriaLegaleIncaricato)) : null;
    this.legaleIncaricato.legale = legaleIncaricato.legale ? JSON.parse(JSON.stringify(legaleIncaricato.legale)) : null;
    this.legaleIncaricato.principale = legaleIncaricato.principale ? legaleIncaricato.principale : false;
    this.legaleIncaricato.revocato = legaleIncaricato.revocato ? legaleIncaricato.revocato : false;
    this.legaleIncaricato.dataInizioIncarico = legaleIncaricato.dataInizioIncarico;
    this.legaleIncaricato.dataCessazioneIncarico = legaleIncaricato.dataCessazioneIncarico;
    this.legaleIncaricato.compensoPattuito = legaleIncaricato.compensoPattuito;
    this.legaleIncaricato.dataAssociazione = legaleIncaricato.dataAssociazione;
    this.legaleIncaricato.dataRevoca = legaleIncaricato.dataRevoca;
    this.legaleIncaricato.documenti = legaleIncaricato.documenti ? legaleIncaricato.documenti : new Array<DocumentoAllegato>();
    this.legaleIncaricato.note = legaleIncaricato.note ? legaleIncaricato.note : '';
    this.legaleIncaricato.tariffeRevisionate = legaleIncaricato.tariffeRevisionate ? [...legaleIncaricato.tariffeRevisionate] : [];
  };
}
